"use client";
import ThemeRegistry from "@/components/Theme/ThemeRegistry";
import React from "react";

const PathComsumer = ({ children }: { children: React.ReactNode }) => {
  return <ThemeRegistry>{children}</ThemeRegistry>;
};

export default PathComsumer;
